import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

///IDIOMAS
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {

    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

  }

  modalEsp = false;
  titulo = "";
  botonesConfirmar = false;

  checkModEsp(){
    if(this.data.tipo){
      // console.log("Es modal tipo especial");
      this.modalEsp = true;
      switch(this.data.tipo){
        case 1: this.titulo = "error"; break;
        case 2: this.titulo = "adver"; break;
        case 3: this.titulo = "aviso"; break;
        case 4: this.titulo = "opSuc"; break;
      }
      if(this.data.confirma)
        this.botonesConfirmar = true;
    }
    // else console.log("es generico");
  }

  ngOnInit(): void
  {
    this.checkModEsp();
  }
}
